const PRIVATE_FIELD =
  /^(?:x-secret|pin|pinCiphertext|tokenCiphertext|webhookSecretCiphertext|access_token|refresh_token|client_secret)$/i
const OAUTH_URL =
  /((?:https?:\/\/[^\s"'<>]+)?\/api\/integrations\/remotelock\/oauth\/callback)\?[^\s"'<>]*/g

export function redactRemoteLockTelemetryString(key: string, value: string): string {
  if (PRIVATE_FIELD.test(key)) {
    return '[redacted]'
  }
  let redacted = value.replace(OAUTH_URL, '$1?[redacted]')
  redacted = redacted.replace(
    /("(?:pin|access_token|refresh_token|client_secret|pinCiphertext|tokenCiphertext|webhookSecretCiphertext)"\s*:\s*")[^"]*(")/gi,
    '$1[redacted]$2'
  )
  return redacted
}
